<div class="pass-card-container">
	<div
		class="pass-card-wrapper"
		[@scalePassCards]="scaleCardTrigger$ | async"
		#cardWrapper
		[style.background-image]="gradient"
		[style.height]="forStaff || data.kioskMode ? (isModal ? '400px' : '451px') : '412px'"
		ondragstart="return false">
		<ng-template #recurringConfigTooltip>
			<div class="ds-tooltip" style="text-align: start">
				<ng-container [ngSwitch]="recurringConfig?.recurrence_type || formState?.data?.date?.schedule_option">
					<span *ngSwitchCase="1">Repeats Daily</span>
					<span *ngSwitchCase="2">Repeats Weekly</span>
				</ng-container>
				<br />
				<span>To edit, please delete this scheduled pass and create a new one.</span>
			</div>
		</ng-template>

		<div class="pass-card-header">
			<div class="header-content">
				<div class="header-info">
					<img class="pass-card-header-icon" [src]="pass.icon | resolveAsset" />
					<div class="pass-card-header-text">
						<span>{{ pass.destination.title }}</span>
						<div
							customToolTip
							[contentTemplate]="recurringConfigTooltip"
							[width]="'281px'"
							[showToolTip]="isRecurringFuture"
							*ngIf="isRecurringFuture && !(fromPast || forFuture)"
							style="display: inline-block">
							<img style="width: 17px" class="ds-ml-10" [src]="'./assets/Repeat (White).svg' | resolveAsset" alt="Recurring Future Pass Icon" />
						</div>
						<div class="card-subtitle ds-flex-center-start" *ngIf="fromPast || forFuture">
							<span notranslate>{{ formatDateTime(pass.start_time) }}</span>
							<div
								customToolTip
								[contentTemplate]="recurringConfigTooltip"
								[width]="'281px'"
								[showToolTip]="isRecurringFuture"
								*ngIf="isRecurringFuture"
								class="ds-flex-center-center">
								<img style="width: 17px" class="ds-ml-10" [src]="'./assets/Repeat (White).svg' | resolveAsset" alt="Recurring Future Pass Icon" />
							</div>
						</div>
					</div>
				</div>
				<div
					*ngIf="passForStudentsComponent"
					appCrossPointerEventTarget
					(pointerClickEvent)="dialogRef.close()"
					style="position: absolute; right: 10px; top: 10px; cursor: pointer">
					<img width="25" height="25" [src]="'./assets/Cancel (Transparent).svg' | resolveAsset" alt="" />
				</div>

				<app-icon-button
					*ngIf="hasClose"
					[srcString]="closeIcon"
					[onDarkShade]="true"
					[size]="20"
					(clickEvent)="cancelEdit($event)"></app-icon-button>
			</div>
			<mat-divider></mat-divider>
		</div>
		<div class="pass-card-content" *ngIf="!isModal">
			<div class="duration-picker">
				<app-traveltype-picker
					[width]="pass.destination.travel_types.length < 2 ? '106px' : '185px'"
					[height]="'32px'"
					(onSelect)="selectedTravelType = $event"
					[choices]="pass.destination.travel_types"
					[altColor]="pass.color_profile.solid_color"></app-traveltype-picker>
				<app-duration-picker
					[forStaff]="forStaff"
					[plural]="selectedStudents.length > 1"
					(onChange)="selectedDuration = $event"
					[maxDuration]="pass.destination.max_allowed_time ? pass.destination.max_allowed_time : 15"></app-duration-picker>
			</div>
			<div class="button">
				<app-card-button
					(onClick)="newPass()"
					[disabled]="performingAction"
					[width]="buttonWidth + 'px'"
					[height]="'79px'"
					[gradientColor]="pass.color_profile.gradient_color">
					<div class="start-pass-content">
						<mat-spinner *ngIf="performingAction" [color]="'accent'" [diameter]="35"></mat-spinner>
						<img
							*ngIf="!performingAction && formState?.data?.destLimitReached"
							class="ds-mx-10"
							[src]="'./assets/Clock (White).svg' | resolveAsset"
							alt="Clock face" />
						<div *ngIf="!performingAction" class="start-pass-content-text" [style.margin-right]="formState?.data?.destLimitReached ? '20px' : '0px'">
							{{ buttonText }}
						</div>
						<img *ngIf="!performingAction" class="button-icon-right" [src]="'./assets/SP Arrow (White).svg' | resolveAsset" />
					</div>
				</app-card-button>
			</div>
		</div>

		<div class="pass-card-content-modal" *ngIf="isModal">
			<div class="center-block">
				<app-travel-view *ngIf="pass.cancellable_by_student || data.kioskMode; else message" [pass]="pass"></app-travel-view>

				<ng-template #message>
					<ng-container *ngIf="!isMobile; else mobile">
						<app-pager [arrowPosition]="'-93px'" [isStaff]="true">
							<div class="page-1" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<app-travel-view [forStaff]="forStaff" [height]="'170px'" [pass]="pass"></app-travel-view>
							</div>
							<div class="page-2" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<div style="display: flex; justify-content: center">
									<div class="message">
										<span [style.font-weight]="'bold'">{{ forStaff ? 'Your message:' : 'Message from' }}</span
										><span ignore [style.font-weight]> {{ pass.issuer.display_name }}</span
										><br />
										<span [attr.notranslate]="pass.issuer_message ? true : null" style="user-select: text">{{
											pass.issuer_message ? pass.issuer_message : 'No Message'
										}}</span>
									</div>
								</div>
							</div>
						</app-pager>
					</ng-container>

					<ng-template #mobile>
						<app-pager [arrowPosition]="'-93px'" [isStaff]="true">
							<div class="page-5" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<app-travel-view [forStaff]="forStaff" [height]="'170px'" [pass]="pass"></app-travel-view>
							</div>
							<div class="page-6" [attr.data-motion-translate]="(frameMotion$ | async).direction">
								<div style="display: flex; justify-content: center">
									<div class="message">
										<span [style.font-weight]="'bold'">{{ forStaff ? 'Your message:' : 'Message from' }}</span
										><span notranslate [style.font-weight]> {{ pass.issuer.display_name }}</span
										><br />
										{{ pass.issuer_message | json }}
										<span [attr.notranslate]="pass.issuer_message ? true : null" style="user-select: text">{{
											pass.issuer_message ? pass.issuer_message : 'No Message'
										}}</span>
									</div>
								</div>
							</div>
						</app-pager>
					</ng-template>
				</ng-template>
			</div>

			<mat-divider *ngIf="!data.kioskMode"></mat-divider>

			<div class="top-block" [style.justify-content]="data.kioskMode ? 'flex-start' : 'center'">
				<div *ngIf="isActive && !forStaff">
					<app-card-button
						*ngIf="!(forStaff || forMonitor)"
						[disabled]="performingAction"
						[width]="buttonWidth + 'px'"
						[height]="'79px'"
						[gradientColor]="pass.color_profile.gradient_color"
						[overlayWidth]="overlayWidth"
						[valid]="valid"
						(onClick)="endPass()">
						<div class="end-pass-content">{{ timeLeft + (timeLeft === '' ? '' : ' -') }} End Pass</div>
					</app-card-button>
				</div>
				<div *ngIf="(fromPast || (forFuture && !forInput)) && !forStaff">
					<span *ngIf="forFuture" style="font-size: 20px; font-weight: bold; color: white">Pass Auto Starts</span>
					<span *ngIf="!forFuture" style="font-size: 20px; font-weight: bold; color: white"
						><var>{{ getDuration() }}</var> - Total Time</span
					>
				</div>

				<app-pager [pages]="pagerPages" [page]="pagerPages" *ngIf="forStaff">
					<div class="page-1 teacher-details" *ngIf="p1Title" [attr.data-motion-translate]="(frameMotion$ | async).direction">
						<span class="bold">{{ (activePage == 1 ? timeLeft + (timeLeft === '' ? '' : ' - ') : '') + p1Title }}</span
						><span class="smaller"
							><br />{{ p1Subtitle }} <span *ngIf="p1Subtitle">-</span> <var>{{ p1Stamp }}</var></span
						>
					</div>
					<div class="page-2 teacher-details" *ngIf="p2Title" [attr.data-motion-translate]="(frameMotion$ | async).direction">
						<span class="bold">{{ (activePage == 2 ? (activePassTime$ | async) + (timeLeft === '' ? '' : ' - ') : '') + p2Title }}</span
						><span class="smaller"
							><br />{{ p2Subtitle + (p2Subtitle === '' ? '' : ' - ') }} <var>{{ p2Stamp }}</var></span
						>
					</div>
					<div class="page-3 teacher-details" *ngIf="p3Title" [attr.data-motion-translate]="(frameMotion$ | async).direction">
						<span class="bold">{{ (activePage == 3 ? timeLeft + (timeLeft === '' ? '' : ' - ') : '') + p3Title }}</span
						><span class="smaller"
							><br />{{ p3Subtitle }} <var>{{ p3Stamp }}</var></span
						>
					</div>
					<div class="page-4 teacher-details" *ngIf="p4Title" [attr.data-motion-translate]="(frameMotion$ | async).direction">
						<span class="bold">{{ (activePage == 4 ? timeLeft + (timeLeft === '' ? '' : ' - ') : '') + p4Title }}</span
						><span class="smaller"
							><br />{{ p4Subtitle }} <var>{{ p4Stamp }}</var></span
						>
					</div>

					<div class="page-5 teacher-details" *ngIf="p1Title" [attr.data-motion-translate]="(frameMotion$ | async).direction">
						<span class="bold">{{ (activePage == 1 ? timeLeft + (timeLeft === '' ? '' : ' - ') : '') + p1Title }}</span
						><span class="smaller"
							><br />{{ p1Subtitle }} <span *ngIf="p1Subtitle">-</span> <var>{{ p1Stamp }}</var></span
						>
					</div>
					<div class="page-6 teacher-details" *ngIf="p2Title" [attr.data-motion-translate]="(frameMotion$ | async).direction">
						<span class="bold">{{ (activePage == 2 ? timeLeft + (timeLeft === '' ? '' : ' - ') : '') + p2Title }}</span
						><span class="smaller"
							><br />{{ p2Subtitle + (p2Subtitle === '' ? '' : ' - ') }} <var>{{ p2Stamp }}</var></span
						>
					</div>
					<div class="page-7 teacher-details" *ngIf="p3Title" [attr.data-motion-translate]="(frameMotion$ | async).direction">
						<span class="bold">{{ (activePage == 3 ? timeLeft + (timeLeft === '' ? '' : ' - ') : '') + p3Title }}</span
						><span class="smaller"
							><br />{{ p3Subtitle }} <var>{{ p3Stamp }}</var></span
						>
					</div>
					<div class="page-8 teacher-details" *ngIf="p4Title" [attr.data-motion-translate]="(frameMotion$ | async).direction">
						<span class="bold">{{ (activePage == 4 ? timeLeft + (timeLeft === '' ? '' : ' - ') : '') + p4Title }}</span
						><span class="smaller"
							><br />{{ p4Subtitle }} <var>{{ p4Stamp }}</var></span
						>
					</div>
				</app-pager>
			</div>
		</div>
		<div class="pass-card-footer" *ngIf="(forStaff || data.kioskMode) && !isModal">
			<div class="student-footer"></div>
			<div class="student-text">{{ studentText }}</div>
		</div>
	</div>

	<div
		class="student-footer-info"
		*ngIf="(forStaff || forKioskMode) && isModal && showStudentInfoBlock"
		[style.margin-top]="forStaff ? '64px' : '20px'">
		<app-student-passes [pass]="pass" [profile]="pass.student"></app-student-passes>
	</div>
</div>

<ng-template #confirmDialogBody let-totalStudents="totalStudents" let-limitReachedStudents="limitReachedStudents">
	<div *ngIf="totalStudents > 1" class="ds-dialog-normal-text">
		<p *ngFor="let s of limitReachedStudents">
			<var>{{ s.displayName }}: {{ s.passLimit }}/{{ s.passLimit }}</var> passes today
		</p>
	</div>

	<div *ngIf="totalStudents === 1" class="ds-dialog-normal-text">
		<span>If it's an emergency, you can override the limit.</span>
	</div>
</ng-template>

<ng-template let-alerts="alerts" #confirmDialogBodyVisibility>
	<ng-container *ngFor="let a of alerts">
		<div class="ds-dialog-title">
			<span>{{ a.phrase }}</span>
		</div>

		<div class="ds-dialog-normal-text ds-mb-10">
			<p notranslate>{{ a.students }}</p>
		</div>
	</ng-container>
</ng-template>
